// Author Liang Gang Qiang
// Date 2021-11-24 16:34:50

import * as model from "@/model/mintalMes/quality/MintalMesQualitySelfInspectGrindModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.MintalMesQualitySelfInspectGrind(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_MINTALMES_QUALITY_URL,
    })
    .buildStore()
